import { PaymentIntent } from "@stripe/stripe-js";
import { PaymentIntentDTO, PaymentResponseDTO, PaymentRequestDTO, SubscriptionPaymentContext } from "../../../models";
import { SubscriptionPaymentResponse } from "../../../models/payments/SubscriptionPaymentResponse";
import BaseDataRepository from "../BaseDataRepository";
import { PaymentModel, } from "../../entities";
import { InvoiceModel } from "../../entities"; 
import { CapturePreAuthRequestDTO, RefundRequestDTO, VoidPreAuthRequestDTO } from "../../entities/payment";

export class PaymentRepo extends BaseDataRepository<PaymentModel> {
  protected baseUrl = 'payment';

  async GetPaymentIntentDetailsAsync(item : string): Promise<PaymentIntent> {
    const response = await this.client.get(`${this.baseUrl}/payment-intent`, item);
    return this.handleResponse<PaymentIntent>(response.data)!;
  }

  async CreatePaymentIntentAsync(item: PaymentIntentDTO): Promise<{client_secret:any}> {
    const response = await this.client.post(`${this.baseUrl}/payment-intent`, item);
    return this.handleResponse<{client_secret:any}>(response)!;
  }

  async HandlePaymentRequestAsync(item: SubscriptionPaymentContext): Promise<SubscriptionPaymentResponse> {
    const response = await this.client.post(`${this.baseUrl}/payment-request`, item);
    return this.handleResponse<SubscriptionPaymentResponse>(response)!;
  }

  async GetCustomerDetailsAsync(email: string): Promise<{email:string; phone:string; postalCode:string}> {
    const response = await this.client.get(`${this.baseUrl}/customer-details`, {params : {email}});
    return this.handleResponse<{email:string; phone:string; postalCode:string}>(response)!;
  }

  async processPaymentAsync(paymentRequest: PaymentRequestDTO): Promise<PaymentResponseDTO>{
    const response = await this.client.post(`${this.baseUrl}/processpayment`, paymentRequest );
    return this.handleResponse<PaymentResponseDTO>(response)!;
  }
  async createStripeClientSecretAsync(invoice: InvoiceModel): Promise<string>{
    const response = await this.client.post(`${this.baseUrl}/createstripeclientsecret`, invoice);
    return this.handleResponse<string>(response)!;
  }

  async capturePreAuthAsync(request: CapturePreAuthRequestDTO): Promise<boolean> {
    const response = await this.client.post(`${this.baseUrl}/capture-preauth`, request);
    return this.handleResponse<boolean>(response)!;
  }

  async voidPreAuthAsync(request: VoidPreAuthRequestDTO): Promise<boolean> {
    const response = await this.client.post(`${this.baseUrl}/void-preauth`, request);
    return this.handleResponse<boolean>(response)!;
  }

  async refundChargeAsync(request: RefundRequestDTO): Promise<boolean> {
    const response = await this.client.post(`${this.baseUrl}/refund`, request);
    return this.handleResponse<boolean>(response)!;
  }
}

export default PaymentRepo;
